import { Container, Graphics } from 'pixi.js';
import { ENTRANCE_DOOR } from '../domain/config.js';
import type { Point } from '../domain/types.js';
import { projectWorld } from './camera.js';
import { label, C } from './primitives.js';

/** Sliding glass leaves share the south wall's actual opening and stay transparent to travelers. */
export class EntranceDoors {
    readonly root = new Container();
    private frame = new Graphics();
    private glass = new Graphics();
    private title = label(this.root, 'ENTRANCE', 0, 0, 11, C.navy, '800');
    private opening = 0;

    constructor() {
        this.title.anchor.set(0.5);
        this.root.addChild(this.glass, this.frame, this.title);
    }

    update(people: Point[], reducedMotion = false) {
        const door = ENTRANCE_DOOR;
        const nearby = people.some(p => Math.abs(p.x - door.x) < 100 && Math.abs(p.y - door.y) < 145);
        const target = nearby ? 1 : 0;
        this.opening = reducedMotion ? target : Math.max(0, Math.min(1, this.opening + (nearby ? 0.12 : -0.08)));
        this.frame.clear(); this.glass.clear();
        const left = projectWorld(door.x - 84, door.y), right = projectWorld(door.x + 84, door.y), center = projectWorld(door.x, door.y);
        this.root.zIndex = center.y + 1;
        this.frame.lineStyle(7, 0xd8f1ed).moveTo(left.x, left.y).lineTo(left.x, left.y - 78)
            .lineTo(right.x, right.y - 78).lineTo(right.x, right.y);
        this.frame.lineStyle(2, 0x3d819b).moveTo(left.x + 3, left.y).lineTo(left.x + 3, left.y - 74)
            .moveTo(right.x - 3, right.y).lineTo(right.x - 3, right.y - 74);
        for (const side of [-1, 1]) {
            const shift = side * this.opening * 70;
            const a = projectWorld(door.x + (side < 0 ? -78 : 0) + shift, door.y);
            const b = projectWorld(door.x + (side < 0 ? 0 : 78) + shift, door.y);
            this.glass.lineStyle(2, 0x6dafc0, 0.85).beginFill(0xb6e7ef, 0.28)
                .drawPolygon([a.x, a.y, b.x, b.y, b.x, b.y - 70, a.x, a.y - 70]).endFill();
            this.glass.lineStyle(2, 0xf6ffff, 0.65).moveTo(a.x + 8, a.y - 52).lineTo(b.x - 8, b.y - 52);
            const handle = side < 0 ? b : a;
            this.glass.lineStyle(3, 0x47758e).moveTo(handle.x, handle.y - 28).lineTo(handle.x, handle.y - 43);
        }
        this.title.position.set(center.x, center.y - 91);
    }

    destroy() { this.root.destroy({ children: true }); }
}
